import React, { useEffect, useState } from "react";
import "../Page.css";
import "./Settings.css";

const TimeZones = () => {
  const [currentTime, setCurrentTime] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [utcOffset, setUtcOffset] = useState("");
  const [isDaytime, setIsDaytime] = useState(true);
  const [isDST, setIsDST] = useState(false);

  useEffect(() => {
    const updateTime = () => {
      const timeZone = "America/New_York";
      const now = new Date();

      // Format time
      const timeString = now.toLocaleTimeString("en-US", {
        timeZone,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      // Format date
      const dateString = now.toLocaleDateString("en-US", {
        timeZone,
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      // Get offset in hours
      const localDate = new Date(
        now.toLocaleString("en-US", { timeZone })
      );
      const offset = -localDate.getTimezoneOffset() / 60;
      const offsetFormatted = `UTC ${offset >= 0 ? "+" : ""}${offset}`;

      // Determine if DST is active (offset is -4 during DST in New York)
      const isDSTActive = offset === -4 ? true : false;

      // Get hour for day/night
      const hour = parseInt(
        now.toLocaleString("en-US", {
          timeZone,
          hour: "2-digit",
          hour12: false,
        }),
        10
      );

      setCurrentTime(timeString);
      setCurrentDate(dateString);
      setUtcOffset(offsetFormatted);
      setIsDST(isDSTActive);
      setIsDaytime(hour >= 6 && hour < 18);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="settings_page_1">
      <div className="time_zone_section">
        <div className="header_tzs">
          <h2>Time Zone </h2>
          <span>{utcOffset}</span>
        </div>
        <div className="body_tzs">

          <div className="time_part">
            <p className="main_time"> {currentTime}</p>
            <p className="">{currentDate}</p>
          </div>
        </div>
        <div className="status_tzs">{isDaytime ? "☀️ Day" : "🌙 Night"}</div>
        <div className="dst_tzs"><div>Daylight Saving Time </div> <div style={{background:"white",color:"#0056b3",borderRadius:"4px",padding:"0 4px"}}>{isDST ? "Active" : " Inactive"}</div></div>
        {/* <p><strong>UTC Offset:</strong> {utcOffset}</p>
        <p><strong>DST Active:</strong> {isDST ? "✅ Yes" : "❌ No"}</p>
        <p><strong>Status:</strong> {isDaytime ? "☀️ Day" : "🌙 Night"}</p> */}
      </div>
    </div>
  );
};

export default TimeZones;
